import { render, staticRenderFns } from "./PhoneContainer.vue?vue&type=template&id=5496a5a8&scoped=true&lang=pug&"
import script from "./PhoneContainer.vue?vue&type=script&lang=js&"
export * from "./PhoneContainer.vue?vue&type=script&lang=js&"
import style0 from "./PhoneContainer.vue?vue&type=style&index=0&id=5496a5a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5496a5a8",
  null
  
)

export default component.exports